// /documents — «Документы» (003, сценарий 4): список протоколов на контроле и загрузка. Право —
// documents.read; загрузку и строки документов решает сервер по областям. ?upload=new открывает
// окно «Новый протокол»: так ведут «Создать ▾ → Протокол» и «Загрузить протокол» на Главной.
// ?folder=<id>&select=<nodeId> открывает папку и выделяет в ней строку (у протокола nodeId — id
// документа): так экран протокола возвращает к его папке. Адрес остаётся как есть: «Назад» ведёт
// в протокол, обновление страницы снова выделяет ту же строку. ?view=shared — «Открытые мне» (023):
// протоколы, к которым пользователю выдали роль.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { DocumentsPage } from '../../features/documents/DocumentsPage.tsx';
import { requireSection } from '../../shell/permissions.ts';

interface DocumentsSearch {
  /** Окно «Новый протокол» открыто. */
  upload?: 'new';
  folder?: string;
  view?: 'recent' | 'favorite' | 'trash' | 'shared';
  /** Строка, которую выделить в открытой папке. */
  select?: string;
}

function parseDocumentsSearch(search: Record<string, unknown>): DocumentsSearch {
  return {
    ...(search.upload === 'new' ? { upload: 'new' as const } : {}),
    ...(typeof search.folder === 'string' && search.folder ? { folder: search.folder } : {}),
    ...(['recent', 'favorite', 'trash', 'shared'].includes(String(search.view))
      ? { view: search.view as DocumentsSearch['view'] }
      : {}),
    ...(typeof search.select === 'string' && search.select ? { select: search.select } : {}),
  };
}

export const Route = createFileRoute('/_app/documents')({
  validateSearch: parseDocumentsSearch,
  beforeLoad: requireSection('documents'),
  staticData: { crumb: 'Документы' },
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { upload, folder, view, select } = Route.useSearch();
  const navigate = useNavigate();
  // Окно закрыто — параметр уходит из адреса, «Назад» не открывает его снова.
  const onUploadClose = useCallback(
    () =>
      void navigate({
        to: '/documents',
        search: { ...(folder ? { folder } : {}), ...(view ? { view } : {}) },
        replace: true,
      }),
    [navigate, folder, view],
  );
  return (
    <DocumentsPage
      uploadNew={upload === 'new'}
      onUploadNewClose={onUploadClose}
      location={{ view: view ?? 'folder', folderId: folder ?? null }}
      {...(select ? { select } : {})}
      onLocationChange={(next) =>
        void navigate({
          to: '/documents',
          search: {
            ...(next.folderId ? { folder: next.folderId } : {}),
            ...(next.view !== 'folder' ? { view: next.view } : {}),
          },
        })
      }
    />
  );
}
